



import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaFacebookF,
} from "react-icons/fa";

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const scrollToSection = (sectionId) => {
    if (sectionId === "home") {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  };
  
  const handleNavigation = (path, e) => {
    // If clicking on the current page, just scroll to top
    if (location.pathname === path) {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    } else {
      // Otherwise navigate to the new page
      // The default Link behavior will handle the navigation
      // When the page loads, it will start at the top automatically
    }
  };

  return (
    <footer className="bg-indigo-800 text-white">
      <div className="max-w-7xl mx-auto px-4 py-8 font-[Lato]">
        {/* Navigation Links */}
        <div className="flex flex-col md:flex-row justify-center items-center space-y-4 md:space-y-0 md:space-x-12 mb-8">
          <Link 
            to="/" 
            className="hover:text-blue-400 transition-colors cursor-pointer"
            onClick={(e) => handleNavigation("/", e)}
          >
            Home
          </Link>
          <Link 
            to="/about" 
            className="hover:text-blue-400 transition-colors cursor-pointer"
            onClick={(e) => handleNavigation("/about", e)}
          >
            About
          </Link>
          <Link 
            to="/feature" 
            className="hover:text-blue-400 transition-colors cursor-pointer"
            onClick={(e) => handleNavigation("/feature", e)}
          >
            Feature
          </Link>
          <Link 
            to="/privacy" 
            className="hover:text-blue-400 transition-colors cursor-pointer"
            onClick={(e) => handleNavigation("/privacy", e)}
          >
            Privacy & Policy
          </Link>
          <Link 
            to="/feedback" 
            className="hover:text-blue-400 transition-colors cursor-pointer"
            onClick={(e) => handleNavigation("/contact", e)}
          >
            Feedback
          </Link>
        </div>

        {/* Social Media Links */}
        {/* <div className="flex justify-center space-x-6 mb-8">
          <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="bg-blue-400 text-white p-2 rounded-full hover:bg-blue-500 transition-colors">
            <FaTwitter className="w-5 h-5" />
          </a>
          <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="bg-pink-500 text-white p-2 rounded-full hover:bg-pink-600 transition-colors">
            <FaInstagram className="w-5 h-5" />
          </a>
          <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="bg-blue-600 text-white p-2 rounded-full hover:bg-blue-700 transition-colors">
            <FaLinkedinIn className="w-5 h-5" />
          </a>
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="bg-blue-800 text-white p-2 rounded-full hover:bg-blue-900 transition-colors">
            <FaFacebookF className="w-5 h-5" />
          </a>
        </div> */}

        {/* Copyright */}
        <div className="text-center text-gray-400 text-sm font-[Lato] pt-6 border-t border-gray-800">
          <p>&copy; {new Date().getFullYear()} Quzy. All rights reserved.</p>
          <p className="mt-2">
            Designed with <span className="text-red-500">❤</span> for a better tomorrow
          </p>
        </div>
      </div>
      <style jsx global>{`
        @import url("https://fonts.googleapis.com/css2?family=Lato:wght@400;700&display=swap");
        @import url("https://fonts.googleapis.com/css2?family=Comfortaa:wght@400;500;600;700&display=swap");
        @import url("https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap");
      `}</style>
    </footer>
  );
};

export default Footer;

